import React from "react";
import {
  Section, LinkedInGithub, EduRow, ExpBlock, Bullets, ProjectLink, MetaLine,
  SkillsValuesOnly, Achievements,
} from "./shared";

const T = ({ children }) => <div className="rt-title">{children}</div>;

const Template1 = ({ data }) => (
  <div className="rt rt1">
    <div className="rt-header">
      <h1>{data.fullName}</h1>
      <p>{[data.email, data.phoneNo].filter(Boolean).join(" | ")}</p>
      {data.location && <p>{data.location}</p>}
      {(data.linkedinId || data.githubId) && (
        <p><LinkedInGithub data={data} /></p>
      )}
    </div>

    <Section
      title={<T>Summary</T>}
      items={[data.summary && <p>{data.summary}</p>]}
    />
    <Section
      title={<T>SKILLS</T>}
      items={[data.skills.length > 0 && <SkillsValuesOnly skills={data.skills} />]}
    />
    <Section
      title={<T>EDUCATION</T>}
      items={data.education.map((e, i) => <EduRow key={i} edu={e} />)}
    />
    <Section
      title={<T>EXPERIENCE</T>}
      items={
        data.experiences.length
          ? data.experiences.map((x, i) => <ExpBlock key={i} exp={x} />)
          : [<p>Fresher</p>]
      }
    />
    <Section
      title={<T>PROJECTS</T>}
      items={data.projects.map((p, i) => (
        <div key={i} className="rt-avoid rt-item">
          <h3>{p.projectName}</h3>
          <MetaLine p={p} />
          <Bullets points={p.description} />
          <ProjectLink url={p.projectLink} />
        </div>
      ))}
    />
    <Section
      title={<T>ACHIEVEMENTS</T>}
      items={[data.others.length > 0 && <Achievements others={data.others} />]}
    />
  </div>
);

export default Template1;